import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NotificationMessage } from '../services/model/notification-message.model';
import { DialogType } from '../services/model/dialog-type.enum';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  public maxCount: number = 1;
  public showDialog: BehaviorSubject<NotificationMessage> =
    new BehaviorSubject<NotificationMessage>(
      new NotificationMessage(DialogType.notSet, '', []),
    );

  public yearList: Object[] = [];

  constructor() {}

  public isNumber(text?: string): boolean {
    let isaNumber: boolean = false;
    try {
      if (text != undefined || text != null) {
        for (let index = 0; index < text?.length; index++) {
          const charCode = text.charCodeAt(index);
          if (charCode >= 48 && charCode <= 57) {
            isaNumber = true;
          } else {
            isaNumber = false;
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
    return isaNumber;
  }

  public generateGuid(): string {
    let guid: string = '';
    try {
      guid = crypto.randomUUID();
    } catch (error) {
      console.error('generateGuid()', error);
    }
    return guid;
  }

  public getISO8601Date(date: Date): string {
    // yyyy-mm-dd
    const d = this.validDateFormat(date);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private validDateFormat(date: Date): Date {
    try {
      if (date.toString().includes('T')) {
        return new Date(date.toString().split('T')[0]);
      } else {
        return date;
      }
    } catch (error) {
      console.error('validDateFormat()', error);
      return date;
    }
  }

  public isNullOrUndefined(property: any, value: any): any {
    if (property === null || value === undefined) {
      throw new Error(`Unable to find ${property}`);
    } else {
      return value;
    }
  }

  public isObjectEmpty(obj: Object): boolean {
    try {
      return obj && Object.keys(obj)?.length === 0;
    } catch (error) {
      console.error('isObjectEmpty()', error);
      return false;
    }
  }
}
